// Flow Protection unlock tokens, stored per flow in localStorage as
// `${flowUid}_token` = {"token": "...", "expiresAt": <ms timestamp>}.

const storageKey = (flowUid) => `${flowUid}_token`;

export const readFlowProtection = (flowUid) => {
  if (!flowUid) return null;
  try {
    const entry = JSON.parse(localStorage.getItem(storageKey(flowUid)));
    if (entry?.token && entry?.expiresAt > Date.now()) return entry;
    if (entry) localStorage.removeItem(storageKey(flowUid));
  } catch (e) {
    // ignore malformed values / blocked storage
  }
  return null;
};

export const writeFlowProtection = (flowUid, entry) => {
  if (!flowUid) return;
  try {
    if (entry?.token) localStorage.setItem(storageKey(flowUid), JSON.stringify(entry));
    else localStorage.removeItem(storageKey(flowUid));
  } catch (e) {
    // ignore write errors (e.g. private browsing quota)
  }
};

export const getFlowProtectionToken = (flowUid) => readFlowProtection(flowUid)?.token || null;

// Falls back to the project in the current route (/project/:projectId/...).
export const currentRouteFlowUid = () => window.location.pathname.match(/^\/project\/([^/]+)/)?.[1] || null;
